<template>
  <div class="uk-card uk-card-default uk-card-body uk-width-medium uk-margin-auto uk-text-center">
    Admin Dashboard<br>
    Work in Progress
  </div>
</template>

<script>
export default {
  name: 'ComponentDashboardAdmin'
}
</script>
